module.exports = __webpack_public_path__ + "img/15.61458a59.jpg";